import * as React from "react";
import { Segment, Header } from "semantic-ui-react";

/*
 * Pure component without any lifecycle methods. Used as a placeholder of a page that is under construction.
 * Additional stylings can be added if needed
 */
export default class UnderConstruction extends React.PureComponent {
  render(): JSX.Element {
    return (
      <Segment className="container-with-bg">
        <Header as="h4">This page is under construction.</Header>
      </Segment>
    );
  }
}
